import React from "react";
import { FormattedMessage } from "react-intl";
import styles from "./footer.module.scss";
import FacebookIcon from "@assets/images/svgs/social/facebook.svg";
import TwitterIcon from "@assets/images/svgs/social/twitter.svg";
import InstagramIcon from "@assets/images/svgs/social/instagram.svg";
import LinkedinIcon from "@assets/images/svgs/social/linkedin.svg";
import YoutubeIcon from "@assets/images/svgs/social/youtube.svg";

const HOW_IT_WORKS_KEY = 'how_it_works';

const uniplacesRow = [
  { key:'about_us', href:`${process.env.HOMEPAGE_URL}/about-us` },
  { key:'blog', href:'https://blog.uniplaces.com' },
  { key:'careers', href:'https://careers.uniplaces.com' },
  { key:'partners', href:`${process.env.HOMEPAGE_URL}/partners` },
  { key:'become_affiliate', href:'https://affiliates.uniplaces.com/' }
];
const joinUsRow = [
  { key:'landlord_portal', href:'https://portal.uniplaces.com/' },
  { key:'list_a_place', href:`${process.env.SS_URL}` },
  { key:'landlord_dashboard', href:`${process.env.AP_URL}` },
];
const helpCentreRow = [
  {
    key: 'how_it_works',
    href: {
      de: `${process.env.HOMEPAGE_URL}/de/how-it-works`,
      en: `${process.env.HOMEPAGE_URL}/how-it-works`,
      es: `${process.env.HOMEPAGE_URL}/es/how-it-works`,
      fr: `${process.env.HOMEPAGE_URL}/fr/how-it-works`,
      it: `${process.env.HOMEPAGE_URL}/it/how-it-works`,
      nl: `${process.env.HOMEPAGE_URL}/nl/how-it-works`,
      pl: `${process.env.HOMEPAGE_URL}/pl/how-it-works`,
      pt: `${process.env.HOMEPAGE_URL}/pt/how-it-works`,
      zh: `${process.env.HOMEPAGE_URL}/zh/how-it-works`,
    }
  },
  { key: 'help_centre', href:'https://help.uniplaces.com/help/s' },
  { key: 'contact_us', href:'https://find.uniplaces.com/contactsupport' },
];

const topCities = [
  { slug: 'lisbon' },
  { slug: 'porto' },
  { slug: 'madrid' },
  { slug: 'barcelona' },
  { slug: 'valencia' },
  { slug: 'milan' },
  { slug: 'rome' },
  { slug: 'london' },
  { slug: 'munich' },
  { slug: 'berlin' }
];
const socialIcons = [
  { herf: 'https://www.facebook.com/uniplaces', label: 'Facebook', component: FacebookIcon },
  { herf: 'https://twitter.com/uniplaces', label: 'Twitter', component: TwitterIcon },
  { herf: 'https://instagram.com/uniplaces/', label: 'Instagram', component: InstagramIcon },
  { herf: 'https://www.linkedin.com/company/uniplaces', label: 'Linkedin', component: LinkedinIcon },
  { herf: 'https://www.youtube.com/user/uniplacesvideos', label: 'Youtube', component: YoutubeIcon }
];

const Footer = ({ locale }) => (
  <footer className={styles.footer}>
    <div className={styles.footer__wrapper}>
      <div className={styles.footer__main}>
        <div className={styles.footer__main__column} key="uniplaces">
          <h3> Uniplaces </h3>
          {
            uniplacesRow.map(({ key, href }) => (
              <a href={href} key={key}>
                <FormattedMessage id={`footer.${key}`} />
              </a>
            ))
          }
        </div>
        <div className={styles.footer__main__column} key="join-us">
          <h3>
            <FormattedMessage id="footer.join_us" />
          </h3>
          {
            joinUsRow.map(({ key, href }) => (
              <a href={href} key={key}>
                <FormattedMessage id={`footer.${key}`} />
              </a>
            ))
          }
        </div>
        <div className={styles.footer__main__column} key="help-centre">
          <h3>
            <FormattedMessage id="footer.help_centre" />
          </h3>
          {
            helpCentreRow.map(({ key, href }) => (
              <a href={key === HOW_IT_WORKS_KEY ? href[locale] : href} key={key}>
                <FormattedMessage id={`footer.${key}`} />
              </a>
            ))
          }
        </div>
      </div>
      <div className={styles.footer__cities}>
        <span>Top Cities</span>
        {
          topCities.map(({ slug }) => (
            <a
              href={`${process.env.HOMEPAGE_URL}/accommodation/${slug}`}
              title={slug}
              key={slug}>
              <FormattedMessage id={`footer.cities.${slug}`} />
            </a>
          ))
        }
      </div>
      <div className={styles.footer__social}>
        <div className={styles.footer__social__terms}>
          <a href="/terms">
            <FormattedMessage id="footer.terms" />
          </a>
          <a href="/terms#privacy-policy">
            <FormattedMessage id="footer.privacy" />
          </a>
          <span>© Uniplaces, { new Date().getFullYear() }</span>
        </div>
        <div className={styles.footer__social__icons}>
          {
            socialIcons.map(({ href, label, component }) => (
              <a href={href} target="_blank" rel="noopener noreferrer" aria-label={label} key={label}>
                {React.createElement(
                  component,
                  { style: {fill: "#fff", fillOpacity: "1"} },
                  null
                )}
              </a>
            ))
          }
        </div>
      </div>
    </div>
  </footer>
);

export default Footer;
